/* PWA service-worker registration & install-prompt event capture.
 * Kept isolated from React so it can run before hydration.
 */

// Detect if the site is already running as an installed PWA
export function isStandalone() {
    if (typeof window === "undefined") return false;
    return (
        window.matchMedia?.("(display-mode: standalone)").matches ||
        window.navigator.standalone === true
    );
}

// Capture beforeinstallprompt so the UI can trigger it later
export function initInstallPromptCapture() {
    if (typeof window === "undefined") return;
    window.addEventListener("beforeinstallprompt", (e) => {
        // Prevent Chrome from auto-showing the mini-infobar
        e.preventDefault();
        window.__vuDeferredInstall = e;
        window.dispatchEvent(new CustomEvent("vu:installable"));
    });
    window.addEventListener("appinstalled", () => {
        window.__vuDeferredInstall = null;
        window.dispatchEvent(new CustomEvent("vu:installed"));
    });
}

// Register /service-worker.js in production only (avoids dev HMR clashes)
export function registerServiceWorker() {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    // Only register in production builds
    if (process.env.NODE_ENV !== "production") return;

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/service-worker.js", { scope: "/" })
            .then((reg) => {
                // Check for updates every hour while the app is open
                setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);

                reg.addEventListener("updatefound", () => {
                    const nw = reg.installing;
                    if (!nw) return;
                    nw.addEventListener("statechange", () => {
                        if (
                            nw.state === "installed" &&
                            navigator.serviceWorker.controller
                        ) {
                            window.dispatchEvent(new CustomEvent("vu:sw-update"));
                        }
                    });
                });
            })
            .catch(() => {
                /* silent: SW is progressive enhancement */
            });
    });
}

export function triggerSWSkipWaiting() {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.getRegistration().then((reg) => {
        reg?.waiting?.postMessage("SKIP_WAITING");
    });
}
